import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaUserFriends, FaUndo } from 'react-icons/fa';
import { MdDelete, MdEdit } from 'react-icons/md';
import styles from "./prestamos.module.css";
import { IoCloseSharp } from "react-icons/io5";
import Swal from 'sweetalert2';
import { api } from '../../utils/services/api';
import { SERVICE } from '../../utils/constants/services';
import Select from 'react-select'
import { use } from 'react';

export default function ModalPrestamos(props) {
    const { clientsAll, clientsSelect, show, setShow, roles, dataEdit, setDataEdit, estados, municipios, ofices, handleUpdate, genders, companieAll, distribuidores, estatusAll, companieSelectM, distribuidorSelectM, estatusSelectM, convenioData, isConvenioMode, setIsConvenioMode, setConvenioData, isReadOnlyMode = false } = props;
    const { clientActual, userId } = useAuth();
    const [number, setNumber] = useState("");
    const [folio, setFolio] = useState("");
    const [total, setTotal] = useState("");
    const [pagos, setPagos] = useState(29);
    const [totalConv, setTotalConv] = useState(0);
    const [menuActive, setMenuActive] = useState("menu01");
    const [dias, setDias] = useState(0);
    const [fecha, setFecha] = useState(new Date().toLocaleDateString('es-MX', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'America/Mexico_City'
    }).split('/').reverse().join('-'));
    const [fechaPrimerPago, setFechaPrimerPago] = useState(new Date().toLocaleDateString('es-MX', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'America/Mexico_City'
    }).split('/').reverse().join('-'));
    const [applyFirstPayment, setApplyFirstPayment] = useState(true);
    const [fechaFin, setFechaFin] = useState("");
    const [montoTotal, setMontoTotal] = useState("");
    const [interes, setInteres] = useState("");
    const [tableA, setTableA] = useState("");
    const [description, setDescription] = useState("");
    const [prestamosTipos, setPrestamosTipos] = useState([]);
    const [prestamoSelect, setPrestamoSelect] = useState(null);
    const [animated, setAnimated] = useState(false);
    const [typeClient, setTypeClient] = useState("CLT");

    // Estados para préstamos de artículos
    const [isArticuloMode, setIsArticuloMode] = useState(false);
    const [tipoPrestamoSelect, setTipoPrestamoSelect] = useState({ value: "normal", label: "Préstamos Normales" });
    const [articulo, setArticulo] = useState("");
    const [marca, setMarca] = useState("");
    const [montoArticulo, setMontoArticulo] = useState("");
    const [pagoArticulo, setPagoArticulo] = useState(500);
    const [diasArticulo, setDiasArticulo] = useState(0);
    const [tableArticulo, setTableArticulo] = useState([]);
    const [descripcionArticulo, setDescripcionArticulo] = useState("");

    // Opciones para el select de tipo de préstamo
    const tiposPrestamoOptions = [
        { value: "normal", label: "Préstamos Normales" },
        { value: "articulos", label: "Préstamos de Artículos" }
    ];

    const [clientsSelectModal, setClientsSelectModal] = useState(null);

    // Estados para lista negra
    const [isClientBanned, setIsClientBanned] = useState(false);
    const [bannedReason, setBannedReason] = useState("");
    const [loadingBannedCheck, setLoadingBannedCheck] = useState(false);

    const [asesores, setAsesores] = useState([]);
    const [asesorSelect, setAsesorSelect] = useState(null);


    const [oficeSelect, setOficeSelect] = useState(null);
    const [stateSelectAval, setStateSelectAval] = useState(null);
    const [municipalSelectAval, setMunicipalSelectAval] = useState(null);
    const [postalCodeSelectAval, setPostalCodeSelectAval] = useState(null);
    const [gendersSelectAval, setGendersSelectAval] = useState(null);

    const [companieSelect, setCompanieSelect] = useState(null);
    const [distribuidorSelect, setDistribuidorSelect] = useState(null);
    const [estatusSelect, setEstatusSelect] = useState(null);

    const [menu06Data, setMenu06Data] = useState({
        idBacking: 0,
        names: "",
        fathersLastName: "",
        mothersLastName: "",
        dateOfBirth: "",
        credentialNumber: "",
        populationRegistrationCode: "",
        addressDescription: "",
        phoneNumber: "",
        addressReferences: ""
    });
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const columns = [
        {
            name: '#',
            selector: row => row.number,
        },
        {
            name: 'Fecha Pago',
            selector: row => row.date.split("T")[0],
        },
        {
            name: 'Pago',
            selector: row => `$ ${row.amount.toLocaleString('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}`,
        }

    ];


    // Función para manejar cambio de tipo de préstamo
    const handleTipoPrestamoChange = (selectedOption) => {
        setTipoPrestamoSelect(selectedOption);
        if (selectedOption.value === "articulos") {
            setIsArticuloMode(true);
            handleLimpiarDatosNormales();
        } else {
            setIsArticuloMode(false);
            handleLimpiarDatosArticulo();
        }
    };

    // Función para limpiar datos de artículos
    const handleLimpiarDatosArticulo = () => {
        setArticulo("");
        setMarca("");
        setDescripcionArticulo("");
        setMontoArticulo("");
        setPagoArticulo(500); // Valor por defecto
        setDiasArticulo(0);
        setTableArticulo([]);
        setFechaFin("");
    };

    // Función para limpiar datos normales
    const handleLimpiarDatosNormales = () => {
        setTotal("");
        setMontoTotal("");
        setInteres("");
        setTableA([]);
        setFechaFin("");
        setTotalConv(0);
        setDias(0);
    };

    const handleRestablecer = () => {
        // Restablecer todos los campos a sus valores por defecto
        setFolio("");
        setTotal("");
        setPagos(29);
        setTotalConv(0);
        setFecha(new Date().toLocaleDateString('es-MX', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            timeZone: 'America/Mexico_City'
        }).split('/').reverse().join('-'));
        setFechaPrimerPago(new Date().toLocaleDateString('es-MX', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            timeZone: 'America/Mexico_City'
        }).split('/').reverse().join('-'));
        setFechaFin("");
        setMontoTotal("");
        setInteres("");
        setApplyFirstPayment(true);
        setTableA([]);
        setDescription("");
        setAnimated(false);
        setMenuActive("menu01");

        // Limpiar datos de artículos
        handleLimpiarDatosArticulo();
        setIsArticuloMode(false);
        setTipoPrestamoSelect({ value: "normal", label: "Préstamos Normales" });

        if (!isConvenioMode) {
            setClientsSelectModal(null);
            setAsesorSelect(null);
            setOficeSelect(null);
            setPrestamoSelect(null);

            if (clientActual != null) {
                handleGetPrestamosType(clientActual.typeClient);
            } else if (clientsSelect != null) {
                handleGetPrestamosType(clientsSelect.typeClient);
            } else {
                handleGetPrestamosType();
            }
        } else {
            if (convenioData) {
                setMontoTotal(convenioData.debt || 0);

                const currentDate = new Date().toLocaleDateString('es-MX', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    timeZone: 'America/Mexico_City'
                }).split('/').reverse().join('-');

                const URL = SERVICE.calcularPrestamo + `?Amount=${convenioData.debt}&LoanSettingId=0&StartDate=${currentDate}&PaymentFrequencyAgreement=DIARIO&AmountPaymentFrequencyAgreement=0&SettingsTypeAgreement=PRESTAMOS EN CONVENIO`;

                api(URL)
                    .then((data) => {
                        if (data.data.data && data.data.data.amortizationTable && data.data.data.amortizationTable.length > 0) {
                            const firstPayment = data.data.data.amortizationTable[0].amount;
                            setTotalConv(Math.round(firstPayment * 100) / 100);
                            setTableA(data.data.data.amortizationTable);
                            setFechaFin(data.data.data.endDate.split("T")[0]);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        }

        Swal.fire({
            position: "center",
            icon: "success",
            title: "Información restablecida",
            showConfirmButton: false,
            timer: 1000
        });
    };

    const formatFolio = (number, totalDigits = 6) => {
        const numberStr = number.toString();
        const zerosNeeded = Math.max(0, totalDigits - numberStr.length);
        const zeros = '0'.repeat(zerosNeeded);
        return `F-${zeros}${numberStr}`;
    };

    const handleAgregar = () => {
        const currentClientType = clientActual !== null ?
            (clientActual.typeClient || "CLT") :
            (clientsSelectModal?.typeClient || typeClient);

        const isEmployee = currentClientType === "EMP";
        const asesorRequired = !isEmployee && asesorSelect === null;

        if (total === "" || fecha === "" ||
            (clientActual === null && clientsSelectModal === null) ||
            prestamoSelect === null || oficeSelect === null || asesorRequired) {
            Swal.fire({
                text: 'Favor de llenar todos los campos',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            })
        }
        else {
            const currentClientType = clientActual !== null ?
                (clientActual.typeClient || "CLT") :
                (clientsSelectModal?.typeClient || typeClient);

            let payload = {
                "clientId": clientActual !== null ? clientActual.Id : clientsSelectModal.value,
                "centralOfficeId": oficeSelect.value,
                "folio": folio,
                "startDate": fecha,
                "endDate": fechaFin,
                "userId": userId,
                "ApplyFirstPayment": applyFirstPayment
            }

            if (isConvenioMode && convenioData) {
                // Para convenios: usar la deuda total como amount y el pago individual como amountPayable
                payload.amount = convenioData.debt || 0; // Monto total de la deuda
                payload.loanSettingId = 0; // ID especial para convenios
                payload.amountInterest = 0; // Sin intereses en convenios
                payload.amountPayable = total; // Monto por pago individual
                payload.originalLoanId = convenioData.id;
                payload.isConvenio = true;
                payload.paymentFrequencyAgreement = "DIARIO";
                payload.amountPaymentFrequencyAgreement = total;
                payload.settingsTypeAgreement = "PRESTAMOS EN CONVENIO";
            } else {
                // Para préstamos normales
                payload.amount = total;
                payload.loanSettingId = prestamoSelect.value;
                payload.amountInterest = interes;
                payload.amountPayable = montoTotal;
                payload.firstPaymentDate = fechaPrimerPago;
                
            }

            if (currentClientType !== "EMP" && asesorSelect !== null) {
                payload.advisorId = asesorSelect.value;
            }
            

            let URL = SERVICE.setPrestamo;
            let METHOD = "POST";
            api(URL, payload, METHOD)
                .then((data) => {
                    // Validar si la respuesta indica error aunque HTTP sea 200
                    if (data.data.status === false) {
                        const errorMessage = data.data.generalMessage || 'Error al crear el préstamo';
                        Swal.fire({
                            position: "center",
                            icon: "error",
                            title: "Error",
                            text: errorMessage,
                            confirmButtonText: 'Aceptar'
                        });
                        return;
                    }
                    
                    const successMessage = "Prestamo Guardado correctamente. Folio: " + formatFolio(data.data.data);
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: successMessage,
                        confirmButtonText: 'Aceptar'
                    });
                    handleUpdate();
                    setShow(false);
                })
                .catch((err) => {
                    console.log(err);
                    let errorMessage = 'Error al crear el préstamo';
                    if (err.response && err.response.data && err.response.data.generalMessage) {
                        errorMessage = err.response.data.generalMessage;
                    }
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: "Error",
                        text: errorMessage,
                        confirmButtonText: 'Aceptar'
                    });
                })
        }

    }
    const handleAgregarConvenio = () => {
        if (montoTotal === "" || fecha === "") {
            Swal.fire({
                text: 'Favor de llenar todos los campos',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            })
        }
        else {
            let payload = {
                "clientId": convenioData.clientId,
                "centralOfficeId": convenioData.centralOfficeId,
                "folio": folio,
                "startDate": fecha,
                "endDate": fechaFin,
                "userId": userId,
                "ApplyFirstPayment": applyFirstPayment,
                "amount": montoTotal,
                "loanSettingId": prestamoSelect ? prestamoSelect.value : 0,
                "amountInterest": 0,
                "amountPayable": montoTotal,
                "advisorId": convenioData.advisorId,
                "PeriodOfTimeAgreement": dias,
                "PaymentFrequencyAgreement": "DIARIO",
                "SettingsTypeAgreement": "PRESTAMOS EN CONVENIO",
                "PreviousLoanIdAgreement": convenioData.id
            }

            let URL = SERVICE.setPrestamo;
            let METHOD = "POST";
            api(URL, payload, METHOD)
                .then((data) => {
                    // Validar si la respuesta indica error aunque HTTP sea 200
                    if (data.data.status === false) {
                        const errorMessage = data.data.generalMessage || 'Error al crear el convenio';
                        Swal.fire({
                            position: "center",
                            icon: "error",
                            title: "Error",
                            text: errorMessage,
                            confirmButtonText: 'Aceptar'
                        });
                        return;
                    }
                    
                    const successMessage = isConvenioMode ? "Convenio creado correctamente" : "Vale Guardado correctamente";
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: successMessage,
                        showConfirmButton: false,
                        timer: 1500
                    });
                    handleUpdate();
                    setShow(false);
                })
                .catch((err) => {
                    console.log(err);
                    let errorMessage = 'Error al crear el convenio';
                    if (err.response && err.response.data && err.response.data.generalMessage) {
                        errorMessage = err.response.data.generalMessage;
                    }
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: "Error",
                        text: errorMessage,
                        confirmButtonText: 'Aceptar'
                    });
                })
        }

    }
    const handleSelectPrestamoTipo = (selectedOption) => {
        setPrestamoSelect(selectedOption);
        if (isConvenioMode && convenioData && selectedOption) {
            const URL = SERVICE.calcularPrestamo + `?Amount=${montoTotal || 0}&LoanSettingId=${selectedOption.value}&StartDate=${fecha}&PaymentFrequencyAgreement=DIARIO&AmountPaymentFrequencyAgreement=0&SettingsTypeAgreement=PRESTAMOS EN CONVENIO`;
            api(URL)
                .then((data) => {
                    if (data.data.data) {
                        const element = data.data.data;
                        setInteres(0);
                        if (element.amortizationTable && element.amortizationTable.length > 0) {
                            const firstPayment = element.amortizationTable[0].amount;
                            setTotalConv(Math.round(firstPayment * 100) / 100);
                            setDias(element.periodOfTime);
                            setFechaFin(element.endDate ? element.endDate.split("T")[0] : "");
                            setTableA(element.amortizationTable);
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    const handleGetPrestamosType = (type = "CLT") => {
        let typeText = type === "CLT" ? "PRESTAMOS EN GENERAL" : "PRESTAMOS EMPLEADOS";
        if (type === "CONV") {
            typeText = "PRESTAMOS EN CONVENIO";
        }
        if (clientActual != null && clientActual.typeClient === "EMP") {
            typeText = "PRESTAMOS EMPLEADOS";
        }
        api(SERVICE.getPrestamosTypesByType + typeText)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            ...element,
                            value: element.id,
                            label: element.settingsType + " - " + element.description
                        });


                    }
                }
                setPrestamosTipos(arrayTemp);
                if (arrayTemp.length > 0) {
                    setPrestamoSelect(arrayTemp[0]);
                }
                else {
                    setPrestamoSelect(null);
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleGetAsesortes = () => {
        api(SERVICE.getAsesoresAll)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.completeName
                        });

                    }
                }
                setAsesores(arrayTemp);
                if (arrayTemp.length > 0) {
                    setAsesorSelect(arrayTemp[0]);
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }

    const checkClientBannedStatus = async (clientId) => {
        if (isReadOnlyMode) {
            setIsClientBanned(false);
            setBannedReason("");
            setLoadingBannedCheck(false);
            return;
        }

        console.log('🔍 checkClientBannedStatus called with clientId:', clientId);
        
        if (!clientId) {
            console.log('❌ clientId is empty');
            setIsClientBanned(false);
            setBannedReason("");
            return;
        }

        setLoadingBannedCheck(true);
        try {
            const url = SERVICE.getBannedListHistory + `?clientId=${clientId}`;
            console.log('📡 Calling API:', url);
            
            const response = await api(url);
            console.log('✅ Response received:', response);
            
            if (response && response.data && response.data.data && response.data.data.length > 0) {
                // Ordenar por ID descendente para obtener el más reciente
                const sortedByIdDesc = response.data.data.sort((a, b) => b.id - a.id);
                const lastRecord = sortedByIdDesc[0];
                console.log('📋 Last record (sorted by ID desc):', lastRecord);
                console.log('🚫 Banned status:', lastRecord.banned);
                
                if (lastRecord.banned === true) {
                    console.log('⛔ CLIENT IS BANNED!');
                    setIsClientBanned(true);
                    setBannedReason(lastRecord.description || "Sin razón especificada");
                    
                    Swal.fire({
                        icon: 'error',
                        title: 'Alerta',
                        html: `<p><strong>No se pueden crear préstamos para este cliente.</strong></p>
                               <p><strong>Razón:</strong> ${lastRecord.description || "Sin razón especificada"}</p>`,
                        confirmButtonText: 'Entendido',
                        confirmButtonColor: '#dc3545'
                    });
                } else {
                    console.log('✅ Client is NOT banned');
                    setIsClientBanned(false);
                    setBannedReason("");
                }
            } else {
                console.log('⚠️ No data found in response');
                setIsClientBanned(false);
                setBannedReason("");
            }
        } catch (error) {
            console.error('❌ Error al verificar lista negra:', error);
            setIsClientBanned(false);
            setBannedReason("");
        } finally {
            setLoadingBannedCheck(false);
        }
    }
    useEffect(() => {
        if (!show) {
            setFolio("");
            setTotal("");
            setFecha(new Date().toLocaleDateString('es-MX', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                timeZone: 'America/Mexico_City'
            }).split('/').reverse().join('-'));
            setFechaPrimerPago(new Date().toLocaleDateString('es-MX', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                timeZone: 'America/Mexico_City'
            }).split('/').reverse().join('-'));
            //setClientsAll([]);
            setClientsSelectModal(null);
            setAsesorSelect(null);
            setOficeSelect(null);
            setDataEdit(null);
            setTableA([]);
            setMenuActive("menu01");
            // Limpiar datos del convenio al cerrar
            if (setIsConvenioMode) setIsConvenioMode(false);
            if (setConvenioData) setConvenioData(null);
            // Limpiar datos de artículos al cerrar
            setIsArticuloMode(false);
            setTipoPrestamoSelect({ value: "normal", label: "Préstamos Normales" });
            handleLimpiarDatosArticulo();
            // Limpiar estados de lista negra
            setIsClientBanned(false);
            setBannedReason("");
            setLoadingBannedCheck(false);
            setApplyFirstPayment(true);
        }
        else {
            // Si está en modo convenio, pre-llenar algunos campos

            if (isConvenioMode && convenioData) {
                // Pre-llenar datos del convenio
                const clientData = clientsAll.find(client => client.value === convenioData.clientId);
                if (clientData) {
                    setClientsSelectModal(clientData);
                }

                // Pre-cargar el monto total con la deuda del préstamo anterior
                setMontoTotal(convenioData.debt || 0);

                // Calcular y pre-cargar el primer pago automáticamente
                const currentDate = new Date().toLocaleDateString('es-MX', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    timeZone: 'America/Mexico_City'
                }).split('/').reverse().join('-');

                const URL = SERVICE.calcularPrestamo + `?Amount=${convenioData.debt}&LoanSettingId=0&StartDate=${currentDate}&PaymentFrequencyAgreement=DIARIO&AmountPaymentFrequencyAgreement=0&SettingsTypeAgreement=PRESTAMOS EN CONVENIO`;
                handleGetPrestamosType("CONV");
                api(URL)
                    .then((data) => {
                        if (data.data.data && data.data.data.amortizationTable && data.data.data.amortizationTable.length > 0) {
                            const firstPayment = data.data.data.amortizationTable[0].amount;
                            setTotalConv(Math.round(firstPayment * 100) / 100);
                            setTableA(data.data.data.amortizationTable);
                            setFechaFin(data.data.data.endDate.split("T")[0]);
                            setDias(data.data.data.periodOfTime);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
            else {
                if (clientActual != null) {
                    handleGetPrestamosType(clientActual.TypeClient);
                } else if (clientsSelect != null) {
                    handleGetPrestamosType(clientsSelect.typeClient);
                } else {
                    handleGetPrestamosType();
                }
            }



            handleGetAsesortes();
        }

    }, [show, isConvenioMode, convenioData, clientsAll])
    function formatDateForInput(dateString) {
        // Dividir la fecha y hora
        const [datePart] = dateString.split(' ');

        // Dividir día, mes y año
        const [day, month, year] = datePart.split('/');

        // Formatear a YYYY-MM-DD (formato que acepta input date)
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    useEffect(() => {
        if (dataEdit != null) {
            setNumber(dataEdit.number);
            setTotal(dataEdit.amount);
            setDescription(dataEdit.description);
            setFechaPrimerPago(formatDateForInput(dataEdit.firstPaymentDate));
            setCompanieSelect(null);
            setDistribuidorSelect(null);
            setEstatusSelect(null);

            let search = companieAll.findIndex(item => item.value == dataEdit.companiesCentralOfficeId);
            if (search !== -1)
                setCompanieSelect(companieAll[search]);
            search = distribuidores.findIndex(item => item.value == dataEdit.distributorId);
            if (search !== -1)
                setDistribuidorSelect(distribuidores[search]);
            search = estatusAll.findIndex(item => item.value == dataEdit.statusId);
            if (search !== -1)
                setEstatusSelect(estatusAll[search]);
        }
        else {
            setFecha(new Date().toLocaleDateString('es-MX', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                timeZone: 'America/Mexico_City'
            }).split('/').reverse().join('-'));
            setFechaPrimerPago(new Date().toLocaleDateString('es-MX', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                timeZone: 'America/Mexico_City'
            }).split('/').reverse().join('-'));
            if (companieSelectM != null) {
                setCompanieSelect(companieSelectM)
            }
            if (estatusSelectM != null) {
                setEstatusSelect(estatusSelectM)
            }
            if (distribuidorSelectM != null) {
                setDistribuidorSelect(distribuidorSelectM)
            }
        }
    }, [dataEdit, companieSelectM, estatusSelectM, distribuidorSelectM])
    useEffect(() => {
        if (fecha != "" && total != "" && total != 0 && (prestamoSelect != null || isConvenioMode)) {
            let URL;

            if (isConvenioMode && convenioData) {
                URL = SERVICE.calcularPrestamo + `?Amount=${montoTotal || 0}&LoanSettingId=${prestamoSelect ? prestamoSelect.value : 0}&StartDate=${fecha}&PaymentFrequencyAgreement=DIARIO&AmountPaymentFrequencyAgreement=${0}&SettingsTypeAgreement=PRESTAMOS EN CONVENIO`;
            } 
            else if ((clientActual !== null ? (clientActual.typeClient || "CLT") : (clientsSelectModal?.typeClient || typeClient)) === "EMP"){
                URL = SERVICE.calcularPrestamo + `?Amount=${total}&LoanSettingId=${prestamoSelect.value}&StartDate=${fecha}&FirstPaymentDate=${fechaPrimerPago}`;
            }
            else {
                URL = SERVICE.calcularPrestamo + `?Amount=${total}&LoanSettingId=${prestamoSelect.value}&StartDate=${fecha}&FirstPaymentDate=${fechaPrimerPago}`;
            }

            api(URL)
                .then((data) => {
                    if (data.data.data) {
                        let element = data.data.data;

                        if (isConvenioMode && convenioData) {
                            setInteres(0);
                            const firstPayment = element.amortizationTable[0].amount;
                            setTotalConv(Math.round(firstPayment * 100) / 100);
                        } else {
                            // Para préstamos normales
                            setInteres(element.interest);
                            setMontoTotal(element.amountPayment);
                        }

                        setFechaFin(element.endDate.split("T")[0]);
                        setTableA(element.amortizationTable);
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
        }
        else {
            setFechaFin("");
            if (!isConvenioMode) {
                setMontoTotal("");
            }
            setInteres("");
        }
    }, [fecha, total, prestamoSelect, isConvenioMode, convenioData, pagos, montoTotal,fechaPrimerPago])
    useEffect(() => {
        if (fecha != null && fecha !== "") {
            setFechaPrimerPago(fecha);
        }
    }, [fecha])
    useEffect(() => {
        if (clientsSelect != null) {
            setClientsSelectModal(clientsSelect);
            setTypeClient(clientsSelect.typeClient);
            handleGetPrestamosType(clientsSelect.typeClient);
            if (!isReadOnlyMode) {
                checkClientBannedStatus(clientsSelect.value);
            }
        }
    }, [clientsSelect, isReadOnlyMode])
    
    // Verificar lista negra cuando se selecciona un cliente manualmente
    useEffect(() => {
        if (isReadOnlyMode) {
            setIsClientBanned(false);
            setBannedReason("");
            return;
        }

        if (clientsSelectModal != null) {
            checkClientBannedStatus(clientsSelectModal.value);
        } else {
            setIsClientBanned(false);
            setBannedReason("");
        }
    }, [clientsSelectModal, isReadOnlyMode])
    
    // Verificar lista negra cuando se abre el modal con clientActual
    useEffect(() => {
        if (!isReadOnlyMode && show && clientActual != null) {
            checkClientBannedStatus(clientActual.Id);
        }
    }, [show, clientActual, isReadOnlyMode])
    useEffect(() => {
        if (isConvenioMode && convenioData) {
            handleGetPrestamosType("CONV");
        }
        else {
            if (clientsSelectModal != null) {
                setTypeClient(clientsSelectModal.typeClient);
                handleGetPrestamosType(clientsSelectModal.typeClient);
            }
            else {
                setTypeClient("CLT");
                handleGetPrestamosType("CLT");
            }
        }

    }, [clientsSelectModal])
    useEffect(() => {
        if (montoTotal !== 0 && menuActive === "menu01") {
            setAnimated(true);
            setTimeout(() => {
                setAnimated(false);
            }, 2000);
        }
    }, [montoTotal])
    useEffect(() => {
        if (convenioData) {
            console.log("convenioData", convenioData);
            if (clientsAll.length > 0) {
                const clientData = clientsAll.find(client => client.value === convenioData.clientId);
                if (clientData) {
                    setClientsSelectModal(clientData);
                }
            }
            if (ofices.length > 0) {
                const officeData = ofices.find(office => office.value === convenioData.centralOfficeId);
                if (officeData) {
                    setOficeSelect(officeData);
                }
            }
            if (asesores.length > 0 && convenioData.advisorId) {
                const asesorData = asesores.find(asesor => asesor.value === convenioData.advisorId);
                if (asesorData) {
                    setAsesorSelect(asesorData);
                }
            }

            // Para convenios: pre-cargar el monto total con la deuda del préstamo anterior
            if (isConvenioMode) {
                setMontoTotal(convenioData.debt || 0);

                // Calcular el primer pago de la tabla de amortización automáticamente
                if (fecha && convenioData.debt) {
                    const URL = SERVICE.calcularPrestamo + `?Amount=${convenioData.debt}&LoanSettingId=0&StartDate=${fecha}&PaymentFrequencyAgreement=DIARIO&AmountPaymentFrequencyAgreement=0&SettingsTypeAgreement=PRESTAMOS EN CONVENIO`;

                    api(URL)
                        .then((data) => {
                            if (data.data.data && data.data.data.amortizationTable && data.data.data.amortizationTable.length > 0) {
                                // Pre-cargar el primer pago redondeado a 2 decimales
                                const firstPayment = data.data.data.amortizationTable[0].amount;
                                setTotalConv(Math.round(firstPayment * 100) / 100);
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            }
        }
    }, [convenioData, clientsAll, ofices, asesores, isConvenioMode, fecha])

    // useEffect para manejar cálculos de préstamos de artículos
    useEffect(() => {
        if (isArticuloMode && fecha !== "" && montoArticulo !== "" && montoArticulo !== 0) {
            const URL = SERVICE.calcularPrestamo + `?Amount=${montoArticulo}&LoanSettingId=0&StartDate=${fecha}&FirstPaymentDate=${fechaPrimerPago}&PaymentFrequencyAgreement=SEMANAL&AmountPaymentFrequencyAgreement=${pagoArticulo || 500}&SettingsTypeAgreement=PRESTAMOS DE ARTICULOS`;

            api(URL)
                .then((data) => {
                    if (data.data.data && data.data.data.amortizationTable && data.data.data.amortizationTable.length > 0) {
                        // Solo actualizar el pago si no se ha establecido manualmente o es el valor por defecto
                        if (pagoArticulo === 0 || pagoArticulo === 500) {
                            const firstPayment = data.data.data.amortizationTable[0].amount;
                            setPagoArticulo(Math.round(firstPayment * 100) / 100);
                        }
                        setTableArticulo(data.data.data.amortizationTable);
                        setFechaFin(data.data.data.endDate.split("T")[0]);
                        setDiasArticulo(data.data.data.periodOfTime);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } else if (isArticuloMode) {
            setPagoArticulo(500); // Mantener valor por defecto
            setTableArticulo([]);
            setFechaFin("");
            setDiasArticulo(0);
        }
    }, [isArticuloMode, fecha, montoArticulo, fechaPrimerPago])

    const handleUpdateTotalConv = (e) => {
        const inputValue = e;
        if (fecha != "" && inputValue != "" && inputValue != 0 && (prestamoSelect != null || isConvenioMode)) {
            let URL;

            if (isConvenioMode && convenioData) {
                // Para convenios, usar el endpoint especial con parámetros adicionales
                URL = SERVICE.calcularPrestamo + `?Amount=${montoTotal || 0}&LoanSettingId=${prestamoSelect ? prestamoSelect.value : 0}&StartDate=${fecha}&PaymentFrequencyAgreement=DIARIO&AmountPaymentFrequencyAgreement=${inputValue}&SettingsTypeAgreement=PRESTAMOS EN CONVENIO`;
            } else {
                // Para préstamos normales
                URL = SERVICE.calcularPrestamo + `?Amount=${total}&LoanSettingId=${prestamoSelect.value}&StartDate=${fecha}`;
            }

            api(URL)
                .then((data) => {
                    if (data.data.data) {
                        let element = data.data.data;

                        if (isConvenioMode && convenioData) {
                            setInteres(0);
                            const firstPayment = element.amortizationTable[0].amount;
                            //setTotalConv(Math.round(firstPayment * 100) / 100);
                            setDias(element.periodOfTime);
                        } else {
                            setInteres(element.interest);
                            setMontoTotal(element.amountPayment);
                        }

                        setFechaFin(element.endDate.split("T")[0]);
                        setTableA(element.amortizationTable);
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
        }
        else {
            setFechaFin("");
            if (!isConvenioMode) {
                setMontoTotal("");
            }
            setInteres("");
        }

    }
    const handleUpdateMontoTotal = (e) => {
        const inputValue = e;
        setMontoTotal(inputValue);
        if (fecha != "" && inputValue != "" && inputValue != 0 && (prestamoSelect != null || isConvenioMode)) {
            let URL;

            if (isConvenioMode && convenioData) {
                // Para convenios, usar el endpoint especial con parámetros adicionales
                URL = SERVICE.calcularPrestamo + `?Amount=${inputValue || 0}&LoanSettingId=${prestamoSelect ? prestamoSelect.value : 0}&StartDate=${fecha}&PaymentFrequencyAgreement=DIARIO&AmountPaymentFrequencyAgreement=0&SettingsTypeAgreement=PRESTAMOS EN CONVENIO`;
            } else {
                // Para préstamos normales
                URL = SERVICE.calcularPrestamo + `?Amount=${total}&LoanSettingId=${prestamoSelect.value}&StartDate=${fecha}`;
            }

            api(URL)
                .then((data) => {
                    if (data.data.data) {
                        let element = data.data.data;

                        if (isConvenioMode && convenioData) {
                            setInteres(0);
                            const firstPayment = element.amortizationTable[0].amount;
                            setTotalConv(Math.round(firstPayment * 100) / 100);
                            setDias(element.periodOfTime);
                        } else {
                            setInteres(element.interest);
                            setMontoTotal(element.amountPayment);
                        }

                        setFechaFin(element.endDate.split("T")[0]);
                        setTableA(element.amortizationTable);
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
        }
        else {
            setFechaFin("");
            if (!isConvenioMode) {
                setMontoTotal("");
            }
            setInteres("");
        }

    }

    // Función para calcular préstamos de artículos
    const handleUpdateMontoArticulo = (inputValue) => {
        setMontoArticulo(inputValue);
        if (fecha !== "" && inputValue !== "" && inputValue !== 0) {
            const URL = SERVICE.calcularPrestamo + `?Amount=${inputValue}&LoanSettingId=0&StartDate=${fecha}&FirstPaymentDate=${fechaPrimerPago}&PaymentFrequencyAgreement=SEMANAL&AmountPaymentFrequencyAgreement=${pagoArticulo || 500}&SettingsTypeAgreement=PRESTAMOS DE ARTICULOS`;

            api(URL)
                .then((data) => {
                    if (data.data.data && data.data.data.amortizationTable && data.data.data.amortizationTable.length > 0) {
                        // Solo actualizar el pago si no se ha establecido manualmente o es 0
                        if (pagoArticulo === 0 || pagoArticulo === 500) {
                            const firstPayment = data.data.data.amortizationTable[0].amount;
                            setPagoArticulo(Math.round(firstPayment * 100) / 100);
                        }
                        setTableArticulo(data.data.data.amortizationTable);
                        setFechaFin(data.data.data.endDate.split("T")[0]);
                        setDiasArticulo(data.data.data.periodOfTime);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            setPagoArticulo(500); // Restablecer a valor por defecto
            setTableArticulo([]);
            setFechaFin("");
            setDiasArticulo(0);
        }
    };

    // Función para actualizar pago de artículo
    const handleUpdatePagoArticulo = (inputValue) => {
        setPagoArticulo(inputValue);
        if (fecha !== "" && montoArticulo !== "" && montoArticulo !== 0 && inputValue !== "" && inputValue !== 0) {
            const URL = SERVICE.calcularPrestamo + `?Amount=${montoArticulo}&LoanSettingId=0&StartDate=${fecha}&FirstPaymentDate=${fechaPrimerPago}&PaymentFrequencyAgreement=SEMANAL&AmountPaymentFrequencyAgreement=${inputValue}&SettingsTypeAgreement=PRESTAMOS DE ARTICULOS`;

            api(URL)
                .then((data) => {
                    if (data.data.data && data.data.data.amortizationTable && data.data.data.amortizationTable.length > 0) {
                        setTableArticulo(data.data.data.amortizationTable);
                        setFechaFin(data.data.data.endDate.split("T")[0]);
                        setDiasArticulo(data.data.data.periodOfTime);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            setTableArticulo([]);
            setFechaFin("");
            setDiasArticulo(0);
        }
    };

    // Función para guardar préstamo de artículos
    const handleAgregarArticulo = () => {
        if (articulo === "" || marca === "" || montoArticulo === "" || montoArticulo === 0 || tableArticulo.length === 0 || fecha === "" || oficeSelect === null || (clientActual === null && clientsSelectModal === null) || asesorSelect === null) {
            Swal.fire({
                text: 'Favor de llenar todos los campos',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            })
        }
        else {
            

            let payload = {
                "clientId": clientActual !== null ? clientActual.Id : clientsSelectModal.value,
                "centralOfficeId": oficeSelect.value,
                "startDate": fecha,
                "endDate": fechaFin,
                "userId": userId,
                "ApplyFirstPayment": applyFirstPayment,
                "folio": "",
                "amount": montoArticulo,
                "loanSettingId": 0,
                "amountInterest": 0,
                "amountPaymentFrequencyAgreement": pagoArticulo,
                "FirstPaymentDate": fechaPrimerPago,
                "PeriodOfTimeAgreement": diasArticulo,
                "PaymentFrequencyAgreement": "SEMANAL",
                "SettingsTypeAgreement": "PRESTAMOS DE ARTICULOS",
                "LoansItems": {
                    "Description": descripcionArticulo,
                    "Item": articulo,
                    "Brand": marca
                }
            }

            let URL = SERVICE.setPrestamo;
            let METHOD = "POST";
            api(URL, payload, METHOD)
                .then((data) => {
                    // Validar si la respuesta indica error aunque HTTP sea 200
                    if (data.data.status === false) {
                        const errorMessage = data.data.generalMessage || 'Error al crear el préstamo de artículo';
                        Swal.fire({
                            position: "center",
                            icon: "error",
                            title: "Error",
                            text: errorMessage,
                            confirmButtonText: 'Aceptar'
                        });
                        return;
                    }
                    
                    const successMessage = "Préstamo de artículo guardado correctamente. Folio: " + formatFolio(data.data.data);
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: successMessage,
                        confirmButtonText: 'Aceptar'
                    });
                    handleUpdate();
                    setShow(false);
                })
                .catch((err) => {
                    console.log(err);
                    let errorMessage = 'Error al crear el préstamo de artículo';
                    if (err.response && err.response.data && err.response.data.generalMessage) {
                        errorMessage = err.response.data.generalMessage;
                    }
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: "Error",
                        text: errorMessage,
                        confirmButtonText: 'Aceptar'
                    });
                })
        }
    };
    return (
        <>
            <div className={styles.bodyModal} style={{ display: show ? "" : "none" }}>
                <div className={`${styles.containerFormMain} animate__animated animate__fadeInDown`} style={{ display: show ? "" : "none" }}>
                    <div className={styles.headerForm}>
                        <h5>
                            {isArticuloMode ? 'Nuevo Préstamo de Artículo' :
                                isConvenioMode ? 'Crear Convenio' :
                                    'Nuevo prestamo'}
                        </h5>
                        <div className={styles.icon} onClick={() => setShow(false)}>
                            <IoCloseSharp />
                        </div>

                    </div>
                    <div className={styles.containerTabs} style={{ display: "" }}>
                        <ul class="nav nav-tabs">
                            <li className={menuActive === "menu01" ? "nav-item-active" : "nav-item"} onClick={() => setMenuActive("menu01")}>
                                <a className={menuActive === "menu01" ? "nav-link active" : "nav-link"}>Datos del prestamo</a>
                            </li>
                            <li className={menuActive === "menu02" ? "nav-item-active" : animated ? "nav-item animate__animated animate__pulse animate__infinite" : "nav-item"} onClick={() => {
                                if (isArticuloMode) {
                                    if (tableArticulo.length > 0) setMenuActive("menu02");
                                } else {
                                    if (montoTotal !== 0 && montoTotal !== "") setMenuActive("menu02");
                                }
                            }}>
                                <a className={
                                    isArticuloMode ?
                                        (tableArticulo.length === 0 ? "nav-link disabled" : menuActive === "menu02" ? "nav-link active" : "nav-link") :
                                        (montoTotal === 0 || montoTotal === "" ? "nav-link disabled" : menuActive === "menu02" ? "nav-link active" : "nav-link")
                                }>Tabla de amortización</a>
                            </li>
                        </ul>
                    </div>
                    <div className={styles.containerForm} style={{ paddingTop: "15px", display: menuActive == "menu01" ? "flex" : "none" }}>
                        {isConvenioMode && convenioData && (
                            <div className={styles.itemForm} style={{
                                width: "100%",
                                backgroundColor: "#f8f9fa",
                                padding: "12px",
                                borderRadius: "6px",
                                marginBottom: "15px",
                                border: "1px solid #e9ecef",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                            }}>
                                <div style={{
                                    textAlign: "center",
                                    marginBottom: "10px",
                                    paddingBottom: "6px",
                                    borderBottom: "1px solid #dee2e6"
                                }}>
                                    <label className="form-label" style={{
                                        marginBottom: "0",
                                        fontSize: "14px",
                                        fontWeight: "600",
                                        color: "#495057"
                                    }}>📋 Préstamo Original</label>
                                </div>

                                <div style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 1fr",
                                    gap: "8px",
                                    marginBottom: "8px"
                                }}>
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "4px 8px",
                                        backgroundColor: "white",
                                        borderRadius: "4px",
                                        border: "1px solid #e9ecef",
                                        fontSize: "13px"
                                    }}>
                                        <span style={{ color: "#6c757d", fontWeight: "500", width: "30%" }}>Folio:</span>
                                        <span style={{ fontWeight: "600", color: "#495057", width: "70%" }}>{convenioData.folio || 'N/A'}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "4px 8px",
                                        backgroundColor: "white",
                                        borderRadius: "4px",
                                        border: "1px solid #e9ecef",
                                        fontSize: "13px"
                                    }}>
                                        <span style={{ color: "#6c757d", fontWeight: "500", width: "30%" }}>Cliente:</span>
                                        <span style={{ fontWeight: "600", color: "#495057", width: "70%" }}>{convenioData.clientName || 'N/A'}</span>
                                    </div>
                                </div>

                                <div style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 1fr",
                                    gap: "8px",
                                    marginBottom: "8px"
                                }}>
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "4px 8px",
                                        backgroundColor: "white",
                                        borderRadius: "4px",
                                        border: "1px solid #e9ecef",
                                        fontSize: "13px"
                                    }}>
                                        <span style={{ color: "#6c757d", fontWeight: "500", width: "30%" }}>Sucursal:</span>
                                        <span style={{ fontWeight: "600", color: "#495057", width: "70%" }}>{convenioData.centralOfficeName || 'N/A'}</span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "4px 8px",
                                        backgroundColor: "white",
                                        borderRadius: "4px",
                                        border: "1px solid #e9ecef",
                                        fontSize: "13px"
                                    }}>
                                        <span style={{ color: "#6c757d", fontWeight: "500", width: "30%" }}>Asesor:</span>
                                        <span style={{ fontWeight: "600", color: "#495057", width: "70%" }}>{convenioData.advisorName || 'N/A'}</span>
                                    </div>
                                </div>

                                <div style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 1fr 1fr",
                                    gap: "6px"
                                }}>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "4px 6px",
                                        backgroundColor: "white",
                                        borderRadius: "4px",
                                        border: "1px solid #e9ecef",
                                        fontSize: "12px"
                                    }}>
                                        <span style={{ color: "#6c757d", fontWeight: "500" }}>Original:</span>
                                        <span style={{ fontWeight: "600", color: "#28a745" }}>
                                            $ {(convenioData.amount || 0).toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                        </span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "4px 6px",
                                        backgroundColor: "white",
                                        borderRadius: "4px",
                                        border: "1px solid #e9ecef",
                                        fontSize: "12px"
                                    }}>
                                        <span style={{ color: "#6c757d", fontWeight: "500" }}>C/Interés:</span>
                                        <span style={{ fontWeight: "600", color: "#17a2b8" }}>
                                            $ {(convenioData.amountPayable || 0).toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                        </span>
                                    </div>
                                    <div style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "4px 6px",
                                        backgroundColor: "white",
                                        borderRadius: "4px",
                                        border: "1px solid #e9ecef",
                                        fontSize: "12px"
                                    }}>
                                        <span style={{ color: "#6c757d", fontWeight: "500" }}>Deuda:</span>
                                        <span style={{ fontWeight: "600", color: "#dc3545" }}>
                                            $ {(convenioData.debt || 0).toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        )}
                        {/* Botón Restablecer */}
                        <div className={styles.itemForm} style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "flex-end",
                            marginBottom: "10px"
                        }}>
                            <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm"
                                onClick={handleRestablecer}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                    fontSize: "12px",
                                    padding: "4px 8px"
                                }}
                            >
                                <FaUndo size={12} />
                                Restablecer
                            </button>
                        </div>
                        {isConvenioMode && convenioData ? "" :
                            (
                                <div className={styles.itemForm} style={{ width: "100%", zIndex: 5, display: clientActual != null ? "none" : "" }}>
                                    <label class="form-label">Cliente: </label>
                                    <Select isClearable={true} options={clientsAll} class="form-control" placeholder="" value={clientsSelectModal} onChange={(e) => setClientsSelectModal(e)} />
                                </div>
                            )}
                        
                        {/* Select para tipo de préstamo (solo para empleados) */}
                        {(typeClient === "EMP" || (clientActual != null && clientActual.typeClient === "EMP")) && !isConvenioMode && (
                            <div className={styles.itemForm} style={{ width: "100%", zIndex: 5 }}>
                                <label class="form-label">Tipo de Préstamo: </label>
                                <Select 
                                    options={tiposPrestamoOptions} 
                                    value={tipoPrestamoSelect} 
                                    onChange={handleTipoPrestamoChange}
                                    class="form-control" 
                                    placeholder="Seleccione el tipo de préstamo..." 
                                />
                            </div>
                        )}
                        
                        {
                            prestamosTipos && prestamosTipos.length > 0 && !isArticuloMode ? (
                                <div className={styles.itemForm} style={{ width: "100%", zIndex: 4 }}>
                                    <label class="form-label">Configuración: </label>
                                    <Select isClearable={true} options={prestamosTipos} class="form-control" placeholder="" value={prestamoSelect} onChange={(e) => handleSelectPrestamoTipo(e)} />
                                </div>
                            )
                                : ""
                        }

                        {isConvenioMode && convenioData ? "" :
                            (
                                <div className={styles.itemForm} style={{ width: "50%", zIndex: 3 }}>
                                    <label class="form-label">Sucursal: </label>
                                    <Select isClearable={true} options={ofices} class="form-control" placeholder="Seleccione..." value={oficeSelect} onChange={(e) => setOficeSelect(e)} />
                                </div>
                            )}
                        {isConvenioMode && convenioData ? "" :
                            (
                                <div className={styles.itemForm} style={{ width: "50%", zIndex: 2, display: typeClient === "EMP" || (clientActual != null && clientActual.typeClient === "EMP") ? "none" : "" }}>
                                    <label class="form-label">Asesor: </label>
                                    <Select isClearable={true} options={asesores} class="form-control" placeholder="Seleccione..." value={asesorSelect} onChange={(e) => setAsesorSelect(e)} />
                                </div>
                            )}


                        <div className={styles.itemForm} style={{ width: "50%", zIndex: 2, display: typeClient === "EMP" || (clientActual != null && clientActual.typeClient === "EMP") ? "" : "none" }}>

                        </div>
                        {
                            isConvenioMode && convenioData ?
                                ""
                                :
                                (
                                    <div className={styles.itemForm} style={{ width: "33%" }}>
                                        <label class="form-label">{isConvenioMode ? "Abono:" : isArticuloMode ? "Valor del Artículo:" : "Monto:"}</label>
                                        <input 
                                            disabled={isConvenioMode} 
                                            type="number" 
                                            class="form-control" 
                                            placeholder="$" 
                                            value={isArticuloMode ? montoArticulo : total} 
                                            onChange={(e) => isArticuloMode ? handleUpdateMontoArticulo(e.target.value) : setTotal(e.target.value)} 
                                        />
                                    </div>
                                )
                        }
                        
                        {/* Campos específicos para artículos */}
                        
                        {/* {
                            ((clientActual !== null ? (clientActual.typeClient || "CLT") : (clientsSelectModal?.typeClient || typeClient)) === "EMP") && (
                                <div className={styles.itemForm} style={{ width: "33%" }}>
                                    <label class="form-label">Fecha Primer Pago:</label>
                                    <input type="date" class="form-control" placeholder="Fecha Inicio" value={fechaPrimerPago} onChange={(e) => setFechaPrimerPago(e.target.value)} />
                                </div>
                            )
                        } */}
                        <div className={styles.itemForm} style={{ width: "22%" }}>
                            <label class="form-label">Fecha Inicio:</label>
                            <input type="date" class="form-control" placeholder="Fecha Inicio" value={fecha} onChange={(e) => setFecha(e.target.value)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "22%" }}>
                                    <label class="form-label">Fecha Primer Pago:</label>
                                    <input type="date" class="form-control" placeholder="Fecha Inicio" value={fechaPrimerPago} onChange={(e) => setFechaPrimerPago(e.target.value)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "22%", display: "flex", flexDirection: "column", justifyContent: "flex-end" }}>
                            <label className="form-label">Aplicar primer pago:</label>
                            <div className="form-check form-switch" style={{ minHeight: "38px", display: "flex", alignItems: "center", gap: "8px" }}>
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    checked={applyFirstPayment}
                                    onChange={(e) => setApplyFirstPayment(e.target.checked)}
                                />
                                <span>{applyFirstPayment ? "Sí" : "No"}</span>
                            </div>
                        </div>

                        {/* Campo de pago diario para artículos o monto total para normales */}
                        {isArticuloMode ? (
                            <div className={styles.itemForm} style={{ width: "33%" }}>
                                <label className="form-label">Pago Semanal:</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder="$"
                                    value={pagoArticulo}
                                    onChange={(e) => setPagoArticulo(e.target.value)}
                                    onBlur={(e) => handleUpdatePagoArticulo(e.target.value)}
                                />
                            </div>
                        ) : (
                            isConvenioMode && convenioData ? "" : (
                                <div className={styles.itemForm} style={{ width: "33%" }}>
                                    <label class="form-label">Interes:</label>
                                    <input type="text" readOnly class="form-control" placeholder="$" value={interes} onChange={(e) => setInteres(e.target.value)} />
                                </div>
                            )
                        )}

                        {/* Períodos para artículos o monto a pagar para normales */}
                        {isArticuloMode ? (
                            <div className={styles.itemForm} style={{ width: "33%" }}>
                                <label className="form-label">Períodos:</label>
                                <input
                                    type="number"
                                    disabled
                                    className="form-control"
                                    value={diasArticulo}
                                />
                            </div>
                        ) : (
                            isConvenioMode && convenioData ? (
                                <div className={styles.itemForm} style={{ width: "33%" }}>
                                    <label class="form-label">{isConvenioMode ? "Deuda total:" : "Monto a pagar:"}</label>
                                    <input type="text" class="form-control" placeholder="$"
                                        value={montoTotal}
                                        onChange={(e) => handleUpdateMontoTotal(e.target.value)} />
                                </div>
                            ) : (
                                <div className={styles.itemForm} style={{ width: "33%" }}>
                                    <label class="form-label">{isConvenioMode ? "Deuda total:" : "Monto a pagar:"}</label>
                                    <input type="text" readOnly class="form-control" placeholder="$"
                                        value={isConvenioMode ? (convenioData?.debt || 0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : montoTotal}
                                        onChange={(e) => setMontoTotal(e.target.value)} />
                                </div>
                            )
                        )}

                        {/* Campos adicionales para convenios */}
                        {isConvenioMode && convenioData && (
                            <>
                                <div className={styles.itemForm} style={{ width: "33%" }}>
                                    <label class="form-label">Abono:</label>
                                    <input type="number" disabled class="form-control" placeholder="$" value={totalConv} />
                                </div>
                                <div className={styles.itemForm} style={{ width: "33%" }}>
                                    <label class="form-label">Periodos:</label>
                                    <input type="number" disabled class="form-control" placeholder="$" value={dias} />
                                </div>
                            </>
                        )}

                        <div className={styles.itemForm} style={{ width: "34%" }}>
                            <label class="form-label">Fecha termino:</label>
                            <input type="date" readOnly class="form-control" placeholder="Fecha Inicio" value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} />
                        </div>
{isArticuloMode && (
                            <>
                                <div className={styles.itemForm} style={{ width: "50%" }}>
                                    <label className="form-label">Artículo:</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Nombre del artículo"
                                        value={articulo}
                                        onChange={(e) => setArticulo(e.target.value)}
                                    />
                                </div>
                                <div className={styles.itemForm} style={{ width: "50%" }}>
                                    <label className="form-label">Marca:</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Marca del artículo"
                                        value={marca}
                                        onChange={(e) => setMarca(e.target.value)}
                                    />
                                </div>
                                 <div className={styles.itemForm} style={{ width: "100%" }}>
                                    <label className="form-label">Descripción:</label>
                                    <textarea
                                        className="form-control"
                                        placeholder="Descripción del artículo"
                                        value={descripcionArticulo}
                                        onChange={(e) => setDescripcionArticulo(e.target.value)}
                                        rows={2}
                                    ></textarea>
                                </div>
                            </>
                        )}
                        <div className={styles.itemForm} style={{ width: "100%" }}>
                            <hr></hr>
                        </div>
                        
                        {/* Alerta de lista negra */}
                        {!isReadOnlyMode && isClientBanned && (
                            <div className={styles.itemForm} style={{ width: "100%" }}>
                                <div className="alert alert-danger d-flex align-items-center" role="alert" style={{ marginBottom: "15px" }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-exclamation-triangle-fill flex-shrink-0 me-2" viewBox="0 0 16 16" role="img" aria-label="Warning:">
                                        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                                    </svg>
                                    <div>
                                        <strong>Alerta</strong>
                                        <br />
                                        <small>Razón: {bannedReason}</small>
                                        <br />
                                        <small>No se pueden crear préstamos para este cliente.</small>
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>

                    <div className={styles.containerForm} style={{ display: menuActive === "menu02" ? "flex" : "none" }}>
                        <div className={styles.itemForm} style={{ width: "100%", zIndex: 3 }}>
                            <DataTable
                                columns={columns}
                                data={isArticuloMode ? tableArticulo : tableA}
                                dense
                                direction="auto"
                                highlightOnHover
                                persistTableHead
                                pointerOnHover
                                responsive
                                striped
                                subHeaderAlign="right"
                                subHeaderWrap
                                fixedHeader
                                fixedHeaderScrollHeight="600px"
                            />
                        </div>


                    </div>
                    <div className={styles.containerBtn}>
                        {!isReadOnlyMode && (
                            <>
                                <button 
                                    className='btn btn-success' 
                                    onClick={
                                        isArticuloMode ? handleAgregarArticulo :
                                            isConvenioMode ? handleAgregarConvenio :
                                                handleAgregar
                                    }
                                    disabled={isClientBanned || loadingBannedCheck}
                                    title={isClientBanned ? `Alerta: ${bannedReason}` : ""}
                                >
                                    {loadingBannedCheck ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Verificando...
                                        </>
                                    ) : (
                                        <>
                                            {isArticuloMode ? "Crear Préstamo Artículo" :
                                                isConvenioMode ? "Crear Convenio" :
                                                    (dataEdit != null ? "Editar" : "Crear")}
                                        </>
                                    )}
                                </button>&nbsp;&nbsp;
                            </>
                        )}
                        <button className='btn btn-danger' onClick={() => setShow(false)}>Cancelar</button>
                    </div>
                </div>
            </div>
        </>
    );
}